import { NavLink, Outlet } from 'react-router';
import AppFooter from '@/components/layout/AppFooter';
import AppHeader from '@/components/layout/AppHeader';
import styles from './AdminLayout.module.css';

export default function AdminLayout() {
  return (
    <>
      <AppHeader />
      <main className={styles.main}>
        <div className={styles.container}>
          <nav className={styles.tabs} aria-label="Admin sections">
            <NavLink
              to="/admin/users"
              className={({ isActive }) => `${styles.tab} ${isActive ? styles.tabActive : ''}`}
            >
              Users
            </NavLink>
            <NavLink
              to="/admin/catalog/products"
              className={({ isActive }) => `${styles.tab} ${isActive ? styles.tabActive : ''}`}
            >
              Products
            </NavLink>
            <NavLink
              to="/admin/catalog/classifications"
              className={({ isActive }) => `${styles.tab} ${isActive ? styles.tabActive : ''}`}
            >
              Classifications
            </NavLink>
            <NavLink
              to="/admin/notifications"
              className={({ isActive }) => `${styles.tab} ${isActive ? styles.tabActive : ''}`}
            >
              Notifications
            </NavLink>
          </nav>
          <Outlet />
        </div>
      </main>
      <AppFooter />
    </>
  );
}